import { getAuthHeaders } from './authHeaders';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

class AddressesAPI {
  static async getAddresses() {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/addresses`, { headers });
    if (!response.ok) {
      if (response.status === 401) throw new Error('NOT_AUTHENTICATED');
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  static async updateAddress(addressId, payload) {
    const headers = await getAuthHeaders({ 'Content-Type': 'application/json' });
    const response = await fetch(`${API_BASE_URL}/addresses/${encodeURIComponent(addressId)}`, {
      method: 'PATCH',
      headers,
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      if (response.status === 401) throw new Error('NOT_AUTHENTICATED');
      const data = await response.json().catch(() => null);
      throw new Error(data?.detail || `HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  static async suggestLocation() {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/addresses/suggest-location`, { headers });
    if (!response.ok) {
      if (response.status === 401) throw new Error('NOT_AUTHENTICATED');
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  static async createAddress(address) {
    const headers = await getAuthHeaders({ 'Content-Type': 'application/json' });
    const response = await fetch(`${API_BASE_URL}/addresses`, {
      method: 'POST',
      headers,
      body: JSON.stringify(address),
    });
    if (!response.ok) {
      if (response.status === 401) throw new Error('NOT_AUTHENTICATED');
      const data = await response.json().catch(() => null);
      throw new Error(data?.detail || `HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  static async deleteAddress(addressId) {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/addresses/${encodeURIComponent(addressId)}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) {
      if (response.status === 401) throw new Error('NOT_AUTHENTICATED');
      const data = await response.json().catch(() => null);
      throw new Error(data?.detail || `HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  static async setDefaultAddress(addressId) {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/addresses/${encodeURIComponent(addressId)}/default`, {
      method: 'POST',
      headers,
    });
    if (!response.ok) {
      if (response.status === 401) throw new Error('NOT_AUTHENTICATED');
      const data = await response.json().catch(() => null);
      throw new Error(data?.detail || `HTTP error! status: ${response.status}`);
    }
    return response.json();
  }
}

export default AddressesAPI;
